import Footer from '../components/layout/Footer'
import Specialty from './Specialty'
import About from './About'
import Projects from './Projects'
import Contact from './Contact'
import Start from './Start'

export default function Home() {
  return (
    <>
      <Start />
      <Specialty />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </>
  )
}
